import { Component } from '@angular/core';
import { PortfolioHealthCheckService } from '../../services/portfolio-health-check/portfolio-health-check.service';
import { PhcData, PhcUrl } from '../../models/interfaces/portfolio-health-check-data';
import { camelToKebabCase, getPHCUrls } from '../../utils/functions.utils';
import { AdobeAnalyticsService, CallToActionType } from '../../services/adobe-analytics/adobe-analytics.service';
import { PageHelpService } from '../page-help/page-help.component.service';
import { environment } from '../../../environments/environment'

@Component({
  selector: 'app-portfolio-health-check',
  templateUrl: './portfolio-health-check.component.html',
  styleUrls: ['./portfolio-health-check.component.scss']
})
export class PortfolioHealthCheckComponent {
  data: PhcData
  urls: PhcUrl = {}

  constructor(
    private phcService: PortfolioHealthCheckService,
    public readonly pageHelpService: PageHelpService,
    private adobeAnalyticsService: AdobeAnalyticsService
  ) {
    this.phcService.getDataPayload().subscribe((data) => {
      this.data = data;
    })
    this.urls = getPHCUrls()
  }

  callToAction(
    name: string,
    type: CallToActionType
  ) {
    if (name === 'learn-about-methodology') name = 'learn-more-about-our-methodology';
    this.adobeAnalyticsService.CreateCTATrigger('portfolio-health-check', name, type)
  }

  openPageHelpDrawer(
    type: string,
    remove?: string,
    callToActionType: CallToActionType = 'Button'
  ) {
    this.pageHelpService.setCurrentDrawerType(type);
    this.pageHelpService.togglePageHelpDrawer();
    this.callToAction(camelToKebabCase(type), callToActionType)
  }
}
